import React from 'react'

import withDefaultStyles from './withDefaultStyles'

// Temporary placeholder requested by product: identical to medium for now.
const RiskGaugeLow = () => (
  <svg width="33" height="31" viewBox="0 0 33 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.4" filter="url(#filter0_f_1224_30269)">
      <path
        d="M13.5262 23.8839C13.0975 24.6265 12.1415 24.8878 11.453 24.3767C10.3364 23.5477 9.35202 22.5493 8.53687 21.4149C7.41898 19.8592 6.64499 18.0834 6.26634 16.2055C5.88769 14.3276 5.91304 12.3906 6.34072 10.5232C6.65258 9.16159 7.17315 7.85972 7.88129 6.66284C8.31789 5.9249 9.3005 5.79526 9.98346 6.31366C10.6664 6.83206 10.7881 7.8018 10.3771 8.5543C9.92117 9.38902 9.58079 10.2845 9.36736 11.2164C9.03804 12.6543 9.01852 14.1458 9.31008 15.5918C9.60164 17.0377 10.1976 18.4051 11.0584 19.603C11.6163 20.3794 12.2771 21.073 13.0208 21.6659C13.6913 22.2003 13.955 23.1414 13.5262 23.8839Z"
        fill="#09DE85"
      />
    </g>
    <path
      d="M13.5937 23.767C13.1278 24.5742 12.0878 24.8587 11.345 24.2957C10.2729 23.483 9.32564 22.5126 8.53687 21.4149C7.41898 19.8592 6.64499 18.0834 6.26634 16.2055C5.88769 14.3276 5.91304 12.3906 6.34072 10.5232C6.64249 9.20566 7.13967 7.94405 7.81313 6.77937C8.27965 5.97256 9.34864 5.83181 10.091 6.39528C10.8333 6.95876 10.9638 8.01277 10.5313 8.83831C10.1286 9.60697 9.82531 10.4263 9.63054 11.2767C9.30978 12.6772 9.29077 14.13 9.57475 15.5384C9.85874 16.9468 10.4392 18.2787 11.2777 19.4455C11.7868 20.1539 12.3839 20.7917 13.053 21.3443C13.7716 21.9377 14.0597 22.9599 13.5937 23.767Z"
      fill="#00C875"
    />
    <path
      d="M28.7261 6.16049C29.454 5.57849 30.5262 5.69226 31.0129 6.48706C31.7155 7.63441 32.2443 8.88309 32.5792 10.1926C33.0538 12.0486 33.1279 13.9844 32.7967 15.8712C32.4655 17.7581 31.7365 19.5528 30.6581 21.1362C29.8973 22.2534 28.9748 23.2473 27.9234 24.0868C27.1951 24.6683 26.1483 24.4101 25.6621 23.615C25.1759 22.8199 25.4382 21.7907 26.1417 21.1793C26.7967 20.6101 27.3775 19.9575 27.8686 19.2364C28.6774 18.0489 29.2241 16.7028 29.4725 15.2877C29.7209 13.8726 29.6653 12.4207 29.3094 11.0288C29.0932 10.1835 28.7694 9.3721 28.3474 8.61384C27.8943 7.79945 27.9982 6.74249 28.7261 6.16049Z"
      fill="#E0E1E5"
    />
    <path
      d="M10.6256 5.74091C9.92546 5.12581 9.85025 4.05022 10.5479 3.43221C11.5549 2.54006 12.692 1.80132 13.923 1.24292C15.6676 0.451525 17.5606 0.0404883 19.4763 0.0371301C21.392 0.033772 23.2865 0.438169 25.0339 1.22345C26.2668 1.77753 27.4065 2.51227 28.4167 3.40088C29.1164 4.01645 29.045 5.09229 28.347 5.70985C27.649 6.3274 26.5898 6.24886 25.865 5.66297C25.1902 5.11746 24.4462 4.65948 23.6504 4.30186C22.3399 3.7129 20.919 3.40961 19.4823 3.41212C18.0455 3.41464 16.6257 3.72292 15.3172 4.31647C14.5227 4.67688 13.7803 5.13746 13.1074 5.68534C12.3847 6.27376 11.3258 6.35601 10.6256 5.74091Z"
      fill="#E0E1E5"
    />
    <path
      d="M19.947 15.9681C19.1182 16.2624 18.2235 15.9528 17.7381 15.2697L8.99997 13.3391L17.8608 12.8871C18.0699 12.6489 18.3398 12.4579 18.6597 12.3442C19.6603 11.9888 20.7598 12.5121 21.1153 13.5125C21.4707 14.5131 20.9476 15.6127 19.947 15.9681Z"
      fill="#313036"
    />
    <defs>
      <filter
        id="filter0_f_1224_30269"
        x="0"
        y="0"
        width="19.7347"
        height="30.6421"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur_1224_30269" />
      </filter>
    </defs>
  </svg>
)

export default withDefaultStyles(RiskGaugeLow)
